import { content } from '../model';
import './title.scss';

export const Title = () => {
	return (
		<div className='newTopiaTitleContainer'>
			<h2 className='newTopiaTitle'>{content.newTopiaTitle}</h2>
		</div>
	);
};
